import { Yup } from 'app/components/core/Form';

const disallowSameColumnName = (column, schema) =>
    schema.notOneOf([column.name], 'New column name must be different from the source column name');

export const SuggestedColumnNameSchema = Yup.string()
    .required()
    .when('column', disallowSameColumnName);
